/**
 * @file   src\mobile\components\InventoryIntroduction\IntroductionData.js
 * @brief  This file is responsible for showing introducion data
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import _ from "lodash";
import {
  removeDecimalZeros,
  thousandSeperatedValue,
} from "../../../helpers/common";
import BedIcon from "../../../images/bed-icon.svg";
import BathIcon from "../../../images/bath-icon.svg";
import SqftIcon from "../../../images/sqft-icon.svg";
import { wantAdSqftValue } from "../../../helpers/createWantAd";

const IntroductionData = (props) => {
  const { introDetails } = props;
  const introList = introDetails;
  const bedRoom = removeDecimalZeros(introList.Bedrooms == 99)
    ? "Any"
    : removeDecimalZeros(introList.Bedrooms) + "+";
  const bathRoom =
    removeDecimalZeros(introList.Bathrooms) == 99
      ? "Any"
      : removeDecimalZeros(introList.Bathrooms) + "+";
  const sqFt = wantAdSqftValue(introList?.Sqft_mn, introList?.Sqft_mx);

  return (
    <>
      <div className="make-intro-details pe-1">
        <h3 className="mb-0 long-txt-fix intro-head-medium">
          {introList.Title_Text}
        </h3>
        <ul className="intro-icons-list">
          {bedRoom && (
            <li>
              <span className="list-txt">{bedRoom}</span>
              <div className="list-icns">
                <img src={BedIcon} alt=""/>
              </div>
            </li>
          )}
          {bathRoom && (
            <li>
              <span className="list-txt">{bathRoom}</span>
              <div className="list-icns">
                <img src={BathIcon} alt=""/>
              </div>
            </li>
          )}{" "}
          {sqFt && (
            <li>
              <span className="list-txt">{sqFt} sqft</span>
              <div className="list-icns">
                <img src={SqftIcon} alt=""/>
              </div>
            </li>
          )}
        </ul>
        <div className="intro-amt">
          $
          {introList?.AskingPrice &&
            thousandSeperatedValue(introList?.AskingPrice)}
        </div>
      </div>
    </>
  );
};
export default IntroductionData;
